import { ReactNode } from "react";
import classNames from "./Popover.module.css";
import * as RadixPopover from "@radix-ui/react-popover";

const Popover = (props: {
  trigger: ReactNode;
  content: ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  side?: RadixPopover.PopoverContentProps["side"];
  align?: RadixPopover.PopoverContentProps["align"];
  contentClassName?: string;
}) => {
  return (
    <RadixPopover.Root open={props.open} onOpenChange={props.onOpenChange}>
      <RadixPopover.Trigger asChild>{props.trigger}</RadixPopover.Trigger>
      <RadixPopover.Portal>
        <RadixPopover.Content
          className={props.contentClassName || classNames.Content}
          side={props.side || "top"}
          align={props.align}
          sideOffset={8}
        >
          {props.content}
        </RadixPopover.Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  );
};

export default Popover;
